import { FC } from 'react';

import { usePage } from '@inertiajs/react';

import { ProductTypesCarousel } from './ProductTypesCarousel';
import { ProductType } from '../../../types';

type PageProps = {
    product_types: ProductType[];
    currentProductType: ProductType;
};

export const ProductTypesList: FC = () => {
    const { product_types, currentProductType } = usePage<PageProps>().props;

    if (!product_types || currentProductType) {
        return null;
    }

    return (
        <section className="border-b pt-2 sm:pt-4 sm:pb-4 md:border-none">
            <div className="container px-0">
                <div className="mb-3 hidden items-center justify-between md:flex">
                    <h2 className="text-lg font-bold md:text-xl">Категорії</h2>
                </div>
                <ProductTypesCarousel productTypes={product_types} />
            </div>
        </section>
    );
};
